'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["category", "superCategory", "page"];
import memoize from 'hs-lodash/memoize';
import * as Category from 'ecosystem-marketplace-core/constants/groupTags/Category';
import * as CategorySlug from 'ecosystem-marketplace-core/constants/urlSlugs/CategorySlug';
import * as SuperCategory from 'ecosystem-marketplace-core/constants/groupTags/SuperCategory';
import * as SuperCategorySlug from 'ecosystem-marketplace-core/constants/urlSlugs/SuperCategorySlug';
import * as GROUPED_CATEGORIES from 'ecosystem-marketplace-core/constants/groupTags/SuperCategoryGroup';
const getCategoryFromSlug = memoize(slug => {
  return Object.keys(Category).find(key => CategorySlug[key] === slug);
});
const getSuperCategoryFromSlug = memoize(slug => {
  return Object.keys(SuperCategory).find(key => SuperCategorySlug[key] === slug);
});
export const getParsedPathParams = _ref => {
  let {
      category,
      superCategory,
      page
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Object.assign({}, rest, {
    category: getCategoryFromSlug(category),
    superCategory: getSuperCategoryFromSlug(superCategory),
    page: page ? parseInt(page, 10) : undefined
  });
};
export const getIsAllReviews = match => match.path.endsWith('/:slug/reviews') && match.isExact;
export const hasValidCategoryParam = params => {
  const {
    category,
    superCategory
  } = getParsedPathParams(params);
  if (!(category && superCategory)) {
    return false;
  }
  const superCategoryGroup = GROUPED_CATEGORIES[superCategory];
  return superCategoryGroup && superCategoryGroup.includes(category);
};